<template>
  <el-table
      :data="transactionList"
      style="width: 100%"
      class="statement-table"
  >
    <el-table-column
      prop="date"
      label="Transaction Date"
      :formatter="getDate"
    />
    <el-table-column
      prop="transfer_type_name"
      label="Transfer Type"
    />
    <el-table-column
      prop="transfer_number"
      label="Transaction ID"
    />
    <el-table-column
      prop="reference"
      label="Description"
    />
    <el-table-column
      prop="debit"
      label="Debit"
      align="center"
    />
    <el-table-column
      prop="credit"
      label="Credit"
      align="center"
    />
    <el-table-column
      prop="balance"
      label="Balance"
      :formatter="getBalanceCell"
    />
    <el-table-column
      prop="status_name"
      label="Status"
    />
  </el-table>
</template>

<script>

import moment from 'moment'

export default {
  props: {
    transactionList: Array,
  },

  methods: {
    getDate(row, column, cellValue) {
      return moment(cellValue).format('YYYY-MM-DD')
    },

    getBalanceCell(row) {
      return `${row.balance} (${row.currency_abbreviation})`
    },
  },
}
</script>

<style lang="scss" scoped>
  .statement-table {
    overflow-x: hidden;
    display: flex!important;
    justify-content: space-between!important;
    flex-direction: column;
  }
</style>
